<template>
    <ac-modal :title="'New Fee'" ref="modal">
        <div class="row">
            <div class="col-md-12">
                <div class="progress" style="height: 36px;">
                    <div class="progress-bar"  role="progressbar" :style="{ width: progress + '%'}">
                        <div style="height: 36px; line-height: 34px; vertical-align: middle;">
                            <span style="font-size: 18px;">{{progressMessage}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div v-show="currentStep == DETAILS">
                    <fee-form :fee-form-instance="feeFormInstance" ref="feeForm">

                    </fee-form>
                    <div class="pull-right">
                        <ac-button :action="detailsComplete">Next</ac-button>
                    </div>
                </div>
                <div v-show="currentStep == PAYER">
                    <payee-options :data-instance="payerInstance" ref="payerSelection" 
                        :banking-info-url="bankingInfoUrl" :isPayer="true">

                    </payee-options>
                    <div class="pull-right">
                        <ac-button :action="back">Back</ac-button>
                        <ac-button :action="payerComplete">Next</ac-button>
                    </div>
                </div>
                <div v-show="currentStep == PAYEE">
                    <payee-options :data-instance="payeeInstance" ref="payeeSelection" 
                        :banking-info-url="bankingInfoUrl">

                    </payee-options>
                    <div class="pull-right">
                        <ac-button :action="back">Back</ac-button>
                        <ac-button :action="payeeComplete">Next</ac-button>
                    </div>
                </div>
                <div v-if="currentStep == REVIEW">
                    <fee-review :fee="fee" ref="feeReview">

                    </fee-review>
                    <div class="pull-right">
                        <ac-button :action="back">Back</ac-button>
                        <ac-button :action="reviewComplete">Finish</ac-button>
                    </div>
                </div>
            </div>
        </div>
    </ac-modal>
</template>

<script>
    import FeeForm from "./FeeForm.vue";
    import {FeeFormClass} from "./FeeFormClass.js";
    import AcButton from "../../../global/customHtmlElements/AcButton.vue";
    import PayeeOptions from "./PayeeOptions.vue";
    import {PayeeFormClass} from "./PayeeFormClass.js";
    import FeeReview from "./FeeReview.vue";
    import {notifications} from "../../../global/notifications.js";
    import { common } from '../../../global/common';

    export default {
        name: "NewFeeModal",
        components: {FeeReview, PayeeOptions, AcButton, FeeForm},
        props: {
            bankingInfoUrl: {required: true, type: [String]},
            feeFormInstance: {required: true, type: [FeeFormClass]},
            payeeInstance: {required: true, type: [PayeeFormClass]},
            payerInstance: {required: false, type: [PayeeFormClass]},
            saveFee: {required: true, type: [Function, Promise]}
        },
        data() {
            return { 
                payerStep: false,
                DETAILS: "Details",
                PAYER: "Payer",
                PAYEE: "Payee",
                REVIEW: "Review",
                currentStep: "Details",
                fee: {},
            };
        },
        computed: {
            steps() {
                let stepsArray = [this.DETAILS];
                if (this.payerStep) stepsArray.push(this.PAYER);
                stepsArray.push(this.PAYEE);
                stepsArray.push(this.REVIEW);
                return stepsArray;
            },
            currentStepNumber() {
                return this.steps.indexOf(this.currentStep);
            },
            stepsCount() {
                return (this.steps.length || 1);
            },
            progress() { 
                return (this.currentStepNumber + 1) * 100 / this.stepsCount;
            },
            progressMessage() {
                return "Step " + (this.currentStepNumber + 1) + " - " + this.currentStep;
            }
        },
        methods: {
            showModal(options = {}) {
                if (options.payerStep) this.payerStep = options.payerStep;
                this.$refs.modal.open();
            },
            async detailsComplete() {
                let fee = await this.$refs.feeForm.getFee();

                if (fee) {
                    this.mapData('fee', fee);
                    console.log("NewFeeModal detailsComplete fee:", fee, this.payerStep);
                    this.payerStep = fee.feeCategory == 1;
                    this.currentStep = this.steps[this.currentStepNumber + 1];
                }
            },
            async payerComplete() {
                let payer = await this.$refs.payerSelection.getPayee();
                // console.log("NewFeeModal payerComplete payer:", payer);
                
                if (!payer) {
                    notifications.showError({title: "Invalid", message: "Invalid Payer"});
                    return;
                }

                this.fee.addingExternalPayer = payer.isExternalPayee;
                this.fee.payerRef = payer;

                if (payer.isExternalPayee) {
                    this.fee.externalPayer = payer;
                } 
                else {
                    this.fee.providerPayer = payer;
                }
                this.currentStep = this.steps[this.currentStepNumber + 1];
            },
            async payeeComplete() {
                let payee = await this.$refs.payeeSelection.getPayee();
                // console.log("NewFeeModal payeeComplete payee:", payee);
                
                if (!payee) {
                    notifications.showError({title: "Invalid", message: "Invalid Payee"});
                    return;
                }

                this.fee.addingExternalPayee = payee.isExternalPayee;
                this.fee.payeeRef = payee;

                if (payee.payeeOptionType == common.PAYEE_OPTIONS.ACCRESA) {
                    this.fee.isAccresaFee = true;
                } 
                else if (payee.isExternalPayee) {
                    this.fee.externalPayee = payee;
                } 
                else {
                    this.fee.providerPayee = payee;
                }
                this.currentStep = this.steps[this.currentStepNumber + 1];
            },
            back() {
                this.currentStep = this.steps[this.currentStepNumber - 1];
            },
            async reviewComplete() {
                let result = await this.saveFee(this.fee);
                //console.log("Result from inner save fee:", result);
                if (result) {
                    this.$refs.modal.close();
                    this.$bus.$emit(this.$bus.$AcEvents.FEE_CHANGE, result);
                }
            }
        }
    }
</script>

<style scoped>
</style>